import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import {
  CheckboxComponent,
  CheckboxTreeComponent,
  DatePickerModule,
  RadioComponent,
  RadioListComponent,
  SearchInputComponent,
} from '@ftr/forms'
import { AnimatedRemoteComponent, ButtonComponent, IconComponent, LoaderComponent } from '@ftr/foundation'
import { ComplexFilterCheckboxListComponent } from './checkbox-list/complex-filter-checkbox-list.component'
import { ComplexFilterCheckboxTreeComponent } from './checkbox-tree/complex-filter-checkbox-tree.component'
import { ComplexFilterComponent } from './complex-filter.component'
import { ComplexFilterService } from './complex-filter.service'
import { ComplexFilterDateRadioListComponent } from './date-radio-list/complex-filter-date-radio-list.component'
import { ComplexFilterDateRangeComponent } from './date-range/complex-filter-date-range.component'
import { ComplexFilterDateComponent } from './date/complex-filter-date.component'
import { ComplexFilterRadioListComponent } from './radio-list/complex-filter-radio-list.component'
import { ComplexFilterEmptyComponent } from './states/empty/complex-filter-empty.component'
import { ComplexFilterErrorComponent } from './states/error/complex-filter-error.component'
import { ComplexFilterLoadingComponent } from './states/loading/complex-filter-loading.component'

@NgModule({
  imports: [
    CommonModule,
    IconComponent,
    DatePickerModule,
    ButtonComponent,
    RadioComponent,
    RadioListComponent,
    CheckboxComponent,
    CheckboxTreeComponent,
    LoaderComponent,
    AnimatedRemoteComponent,
    SearchInputComponent,
  ],
  declarations: [
    ComplexFilterCheckboxListComponent,
    ComplexFilterCheckboxTreeComponent,
    ComplexFilterComponent,
    ComplexFilterDateRadioListComponent,
    ComplexFilterDateRangeComponent,
    ComplexFilterEmptyComponent,
    ComplexFilterErrorComponent,
    ComplexFilterLoadingComponent,
    ComplexFilterRadioListComponent,
    ComplexFilterDateComponent,
  ],
  exports: [ComplexFilterComponent],
  providers: [ComplexFilterService],
})
export class ComplexFilterModule {}
